import React from 'react';

type TMoreIcon = {
  className?: string;
  style?: any;
};

export const MoreIcon: React.FC<TMoreIcon> = ({ className, style }) => (
  <svg width="5" height="17" viewBox="0 0 5 17" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.78846 2.14423C3.78846 3.05231 3.05232 3.78846 2.14423 3.78846C1.23615 3.78846 0.5 3.05231 0.5 2.14423C0.5 1.23615 1.23615 0.5 2.14423 0.5C3.05232 0.5 3.78846 1.23615 3.78846 2.14423Z"
      stroke="white"
      stroke-linecap="round"
    />
    <path
      d="M3.78852 14.1882C3.78852 15.0963 3.05237 15.8325 2.14429 15.8325C1.2362 15.8325 0.500056 15.0963 0.500056 14.1882C0.500056 13.2801 1.2362 12.544 2.14429 12.544C3.05237 12.544 3.78852 13.2801 3.78852 14.1882Z"
      stroke="white"
      stroke-linecap="round"
    />
    <path
      d="M3.78846 8.18822C3.78846 9.0963 3.05232 9.83245 2.14423 9.83245C1.23615 9.83245 0.5 9.0963 0.5 8.18822C0.5 7.28014 1.23615 6.54399 2.14423 6.54399C3.05232 6.54399 3.78846 7.28014 3.78846 8.18822Z"
      stroke="white"
      stroke-linecap="round"
    />
  </svg>
);
